import type { LineItem as LineItemModel } from '@pperform/pp-data-mappers';
import { Stack } from 'components/Stack';
import type {
  ReturnRequestLineItemError,
  ReturnLineItem,
  SelectedLineItem,
  ReturnReason,
} from '../../../../../../interfaces';
import { LineItem } from '../LineItem';
import { getStateKey } from '../../utils';

interface LineItemsProps {
  shipmentLineItems: LineItemModel[];
  selectedLineItems: SelectedLineItem;
  errors?: ReturnRequestLineItemError;
  onChangeReturnQuantity: (quantity: number, stateKey: string) => void;
  onChangeReasonForReturn: (reason: ReturnReason, stateKey: string) => void;
  onChangeCustomReasonForReturn: (reason: string, stateKey: string) => void;
  onSelectLineItem: (returnLineItem: ReturnLineItem, stateKey: string) => void;
  onDeselectLineItem: (stateKey: string) => void;
  /**
   * ID of the form title element for aria association
   */
  formTitleId?: string;
}

export const LineItems = ({
  errors,
  shipmentLineItems,
  selectedLineItems,
  onChangeReturnQuantity,
  onChangeReasonForReturn,
  onChangeCustomReasonForReturn,
  onSelectLineItem,
  onDeselectLineItem,
  formTitleId,
}: LineItemsProps) => {
  return (
    <div role="group" aria-labelledby={formTitleId}>
      <Stack
        direction="column"
        gap={{
          desktop: 16,
          mobile: 8,
        }}
        align="stretch"
      >
        {shipmentLineItems.map((shipmentLineItem) => {
          const selectedLineItem = selectedLineItems.get(
            getStateKey(shipmentLineItem),
          );

          const onSelectItem = () => {
            const returnLineItem: ReturnLineItem = {
              item: shipmentLineItem,
              quantity: shipmentLineItem.quantity,
              reason: undefined,
              customReason: '',
            };
            onSelectLineItem(returnLineItem, getStateKey(shipmentLineItem));
          };

          const onDeselectItem = () => {
            onDeselectLineItem(getStateKey(shipmentLineItem));
          };

          const onChangeQuantity = (quantity) => {
            onChangeReturnQuantity(quantity, getStateKey(shipmentLineItem));
          };

          const onChangeReason = (reason) => {
            onChangeReasonForReturn(reason, getStateKey(shipmentLineItem));
          };

          const onChangeCustomReason = (reason) => {
            onChangeCustomReasonForReturn(
              reason,
              getStateKey(shipmentLineItem),
            );
          };

          return (
            <LineItem
              lineItem={shipmentLineItem}
              selectedLineItem={selectedLineItem}
              errors={errors?.[selectedLineItem?.item.guid]}
              onChangeReturnQuantity={onChangeQuantity}
              onChangeReasonForReturn={onChangeReason}
              onChangeCustomReasonForReturn={onChangeCustomReason}
              onSelectLineItem={onSelectItem}
              onDeselectLineItem={onDeselectItem}
              key={shipmentLineItem.guid}
            />
          );
        })}
      </Stack>
    </div>
  );
};
